/**
 * Themes Index
 *
 * Exporta todos os themes disponíveis.
 *
 * @since 2025-12-16
 */

export { mkf2015Theme } from './mkf2015';
export { copaEnergiaTheme } from './copaenergia';

import { mkf2015Theme } from './mkf2015';
import { copaEnergiaTheme } from './copaenergia';
import type { Theme } from '../types';

/**
 * Registry de todos os themes disponíveis
 */
export const themes: Record<string, Theme> = {
  mkf2015: mkf2015Theme,
  copaenergia: copaEnergiaTheme,
};

/**
 * Theme padrão
 */
export const defaultTheme = mkf2015Theme;

/**
 * Lista de IDs de themes disponíveis
 */
export const availableThemeIds = Object.keys(themes);

/**
 * Obter theme por ID
 */
export function getThemeById(id: string): Theme | undefined {
  return themes[id];
}
